export default {
    default: {
        actions: 'Ações',
    },

    actions: {
        show: 'Ver Detalhes',
        edit: 'Editar',
        delete: 'Excluir',
        restore: 'Restaurar',
    },

    feedbacks: {
        errors: {
            delete: 'Não foi possível excluir o {resource}.',
            restore: 'Não foi possível resturar o {resource}.',
            loadingList: 'Não foi possível carregar a lista de {resource}.',
            copy: 'Erro ao copiar o {resource}.',
        },

        success: {
            save: '{resource} salvo com sucesso',
            delete: '{resource} excluído com sucesso',
            restore: '{resource} resturado com sucesso',
            copy: '{resource} copiado com sucesso',
            sync: '{resource} sincronizado com sucesso',
            cancel: 'Cancelado com sucesso',
        },
    },

    activation: {
        name: 'Ativação | Ativações',
        attributes: {
            value: 'Valor',
            installments: 'Parcelas',
            module: 'Módulo/Pacote de Plano',
            amount: 'Quantidade',
            activatable_type: 'Tipo de Ativação',
        },
        labels: {
            module: 'Módulo',
            plan_package: 'Pacote de Plano',
        },
        hints: {
            value:
                'Valor de ativação ao selecionar um plano ou autoatendimento',
            installments: 'Número de parcelas do valor de ativação',
            module:
                'Módulo ou pacote de plano que garante um valor a mais de ativação',
            amount:
                'Quantidade mínima do Módulo/Pacote de Plano para liberar ativação',
        },
        activatable: {
            unknown_plan_package: 'Plano desconhecido',
            unknown_module: 'Módulo desconhecido',
            unknown: 'Não definido',
        },
    },

    address: {
        name: 'Endereço | Endereços',
    },

    bank_account: {
        name: 'Conta Bancária | Contas Bancárias',
    },

    bill: {
        name: 'Fatura | Faturas',
        attributes: {
            reseller_id: 'Parceiro',
            due_at: 'Vencimento',
            paid_at: 'Data Pagamento',
            reference: 'Referência',
            totalValue: 'Valor',
            has_negotiation: 'Parcelada',
        },
    },

    billNegotiation: {
        name: 'Negociação de Fatura | Negociações de Fatura',
        attributes: {
            installments: 'Parcelas',
            down_payment_on: 'Vencimento da Entrada',
            down_payment_value: 'Valor da Entrada',
            down_payment_method: 'Forma de pagamento da entrada',
            first_on: 'Primeira Parcela',
            installment_value: 'Valor da Parcela',
        },
        hints: {
            installment_value:
                'O valor da primeira parcela pode sofrer alteração de alguns centavos para divisões não exatas.',
        },
    },

    cancellationRequisition: {
        name: 'Solicitação de Cancelamento | Solicitações de Cancelamento',
        attributes: {
            created_at: 'Data de Solicitação',
            reason: 'Motivo',
            note: 'Observação',
            customer: 'Cliente',
            retained: 'Retenção',
        },
        getters: {
            retained: {
                null: 'Pendente',
                true: 'Retido',
                false: 'Cancelado',
                deleted: 'Solicitação Excluída',
            },
        },
        hints: {
            adminRequest: 'Solicitar e efetuar o cancelamento imediatamente.',
        },
    },

    category: {
        name: 'Categoria | Categorias',
        attributes: {
            name: 'Nome',
            percent: '% Comissão',
            discount_percentage: '% Desconto',
            reseller_type_ids: 'Tipos de Parceiros',
            badge_icon: 'Ícone',
            badge_color: 'Cor do Ícone',
            description: 'Descrição',
        },
        hints: {
            name: 'Nome que será utilizado para mostrar o nível do parceiro',
            percent: 'Porcentagem de comissão do nível',
            discount_percentage: 'Procentagem de desconto na fatura do nível',
            description:
                'Informações detalhadas de como funciona o nível da parceria',
        },
        tabs: {
            categorization_rules: 'Regras de Categorização',
            cycle_rules: 'Regras de Ciclo',
        },
    },

    cycle_rule: {
        name: 'Regra de Ciclo | Regras de Ciclo',
        attributes: {
            min_value: 'Mín. Clientes',
            max_value: 'Máx. Clientes',
            percentage: '% Comissão',
        },
        hints: {
            min_value: 'Número mínimo de clientes para esta faixa',
            max_value:
                'Número máximo de clientes para esta faixa (deixe vazio para sem limite)',
            percentage:
                'Percentual de comissão específico para esta faixa de clientes',
        },
    },

    certificate: {
        name: 'Certificado | Certificados',
    },

    commission: {
        name: 'Comissão | Comissões',
    },

    contact: {
        name: 'Contato | Contatos',
        attributes: {
            name: 'Nome',
            email: 'E-mail',
            emails: 'E-mails',
            phone: 'Telefone',
            phones: 'Telefones',
            support: 'Contato de Suporte',
            financial: 'Contato Financeiro',
        },
        hints: {
            support:
                'Contato que será exibida para o cliente nas telas de suporte.',
            financial:
                'Contato que será exibida para o cliente nas telas de bloqueio financeiro.',
        },
    },

    customer: {
        name: 'Cliente | Clientes',
        attributes: {
            activated_at: 'Ativado em',
            canceled_at: 'Cancelado em',
            cnpj: 'CNPJ',
            contacts: 'Contatos',
            cpf: 'CPF',
            created_at: 'Criado em',
            deleted_at: 'Excluído em',
            email: 'E-mail',
            legal_name: 'Razão Social',
            phone: 'Telefone',
            reseller_id: 'Parceiro',
            status: 'Status',
            trade_name: 'Nome Fantasia',
        },
        actions: {
            block: 'Bloquear',
            unblock: 'Desbloquear',
            requestCancellation: 'Cancelar',
            createProposal: 'Criar Proposta de Plano',
        },
        getters: {
            status: {
                trial: 'Trial',
                expired: 'Expirado',
                active: 'Ativo',
                blocked: 'Bloqueado',
                cancellation_requested: 'Cancelamento Solicitado',
                canceled: 'Cancelado',
                deleted: 'Excluído',
                ignored: 'Ignorado',
            },
        },
        feedbacks: {
            changed_plan: 'Plano atualizado com sucesso.',
        },
    },

    integration: {
        name: 'Integração | Integrações',
        attributes: {
            name: 'Nome',
            url: 'URL',
            logo: 'Logo',
        },
        hints: {
            logo: 'Selecione um logo (180x180 px)',
            logo2:
                'Recomenda-se o uso de uma imagem com 180 px de altura e de largura ou proporcinal a estas medidas.',
            cover: 'Selecione uma imagem de capa (1500x150 px)',
            cover2:
                'Recomenda-se o uso de uma imagem com 150px de altura e 1500px largura ou proporcinal a estas medidas.',
        },
        alerts: {
            url:
                'Atenção! Revise este campo cuidadosamente. O preenchimento incorreto pode interromper os serviços desta integração.',
        },
    },

    landingPage: {
        name: 'Página de Captação | Páginas de Captação',
        attributes: {
            name: 'Nome',
            url: 'URL',
            resellers: 'Parceiros',
        },
    },

    lead: {
        name: 'Prospect | Prospects',
        attributes: {
            reseller_id: 'Parceiro',
            customer_id: 'Cliente',
            landing_page_id: 'Página de Captação',
            name: 'Nome',
            trade_name: 'Nome Fantasia',
            legal_name: 'Razão Social',
            responsible_name: 'Nome do Responsável',
            activity_area: 'Área de Atividade',
            cpf: 'CPF',
            cnpj: 'CNPJ',
            email: 'E-mail',
            phone: 'Telefone',
            valid_until: 'Data Limite',
            birthday: 'Data Aniversário',
            days_left: 'Dias restantes',
            exclusive: 'Exclusividade',
            status: 'Status',
        },
        labels: {
            legal_person: 'Pessoa Jurídica',
            normal_person: 'Pessoa Física',
        },
    },

    mail: {
        name: 'E-mail | E-mails',
        attributes: {
            subject: 'Assunto',
            recipients: 'Destinatários',
            bcc: 'Cópia Oculta',
            variables: 'Variáveis',
            content: 'Conteúdo',
        },
        hints: {
            subject: 'Assunto do E-mail',
            recipients: 'Destinatários separado por ";"',
            content: 'Conteúdo do E-mail',
        },
    },

    media: {
        name: 'Material de Apoio | Materiais de Apoio',
    },

    period: {
        name: 'Período | Períodos',
        attributes: {
            customer: 'Cliente',
            due_at: 'Vencimento',
            end_at: 'Fim',
            plan: 'Plano',
            situation: 'Situação',
            start_at: 'Início',
            total_value: 'Valor Total',
            value: 'Valor',
            paid_at: 'Pago em',
            reseller_payment: 'Remuneração',
        },
    },

    planProposal: {
        name: 'Proposta de Plano | Propostas de Plano',
        attributes: {
            general_info: 'Informações Gerais',
            plan: 'Plano:',
            price: 'Preço:',
            starting_from: 'a partir de',
            summary: 'Resumo do Plano',
            fixed_modules: 'Módulos fixos:',
            optional_modules: 'Módulos opcionais:',
            addon_label: '(add-on)',
            implementation_fee: 'Taxa de Implementação',
            charged_first_installment: '(cobrado na primeira parcela)',
            total_price: 'Preço Total',
            per_month: '/ mês',
            discount: 'Desconto',
            final_price: 'Preço Final',
            loyalty_title: 'Plano fidelizado',
            loyalty_description:
                'Seu plano será fidelizado por 12 meses, garantindo um desconto de {discount} no valor total.',
            loyalty_checkbox:
                'Ativar plano fidelizado por 12 meses e receber {discount}% de desconto.',
            third_party_description: '* Ao selecionar um aplicativo de parceiro, o valor será cobrado diretamente do cliente sem possivel alteração de valor.'
        },
        show: {
            texts: {
                'title-prefix': 'Dados',
                'fixed-modules': 'Módulos Fixos',
                'optional-modules': 'Módulos Opcional',
                'total-price': 'Valor Total',
                discount: 'Desconto',
                'config-price': 'Taxa de Implementação',
                'final-price': 'Valor Final',
                'config-price-suffix': 'cobrado na primeira parcela',
                'base-price': 'Preço Base',
            },
        },

        labels: {
            loyalty: 'Plano com fidelidade?',
            'new-plan': 'Plano novo/renovação de plano?',
            'setup-and-configuration':
                'Cobrar valor de setup e configuração inicial?',
        },
    },

    planPackage: {
        form: {
            labels: {
                'base-price': 'Preço Base',
                package: 'Selecione o Pacote de Plano',
            },
        },
    },

    popupSetting: {
        name: 'Configuração de Popup | Configurações de Popups',
        attributes: {
            title: 'Título',
            content: 'Conteúdo',
            slug: 'Identificador',
            persistent: 'Persistente',
            touchable: 'Removível',
            redirect_to: 'Redirecionamento',
            width: 'Largura',
        },
        hints: {
            width:
                'Para popups responsivos defina valores em porcentagem ex. 60% ou para largura fixa defina o valor em pixels ex. 1100px.',
            content:
                "O valor inserido nesse campo será rendererizado em HTML no popup. Dica ao copiar iframe's do Youtube altere a propriedade width para 100% e remova a propriedade height para que a altura seja calculada autoticamente pelo portal.",
            persistent: 'Ao marcar o popup não fechará ao clicar fora.',
            touchable: 'Ao marcar a opção "Não exibir novamente" será exibida.',
        },
    },

    reseller: {
        name: 'Parceiro | Parceiros',
        attributes: {
            lastActivation: 'Última ativação',
            indicators: 'Estatísticas',
            mmr: 'MMR',
            customers: 'Clientes',
        },
        getters: {
            defaulter: {
                true: 'Inadimplente',
                false: 'Adimplente',
            },
        },
    },

    resellerUser: {
        name: 'Usuário de Parceiro | Usuários de Parceiro',
        attributes: {
            name: 'Nome',
            email: 'E-mail',
        },
    },

    rule: {
        name: 'Regra de Categorização | Regras de Categorização',
        attributes: {
            type: 'Tipo',
            min_value: 'Valor Mínimo',
            max_value: 'Valor Máximo',
            percentage: 'Percentual',
        },
        getters: {
            type: {
                customer: 'Qtd. de Clientes',
                revenue: 'Faturamento',
            },
        },
        hints: {
            min_value: 'Valor mínimo para o nível de parceria',
            max_value: 'Valor máximo para o nível de parceria',
            percentage: 'Percentual para consultores de negócio',
        },
    },

    role: {
        name: 'Perfil de Usuários | Perfis de Usuários',
        attributes: {
            account_manager: 'Gerente de Contas',
        },
    },

    user: {
        name: 'Usuário | Usuários',
    },
}
